import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_0c8eb7d0 from 'nuxt_plugin_plugin_0c8eb7d0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_intersectionobserver_5167c258 from 'nuxt_plugin_intersectionobserver_5167c258' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_image_aaba817e from 'nuxt_plugin_image_aaba817e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_deviceplugin_7007b3d1 from 'nuxt_plugin_deviceplugin_7007b3d1' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_device_270d8d4a from 'nuxt_plugin_device_270d8d4a' // Source: ../plugins/device (mode: 'all')
import nuxt_plugin_services_ac10db5c from 'nuxt_plugin_services_ac10db5c' // Source: ../plugins/services (mode: 'all')
import nuxt_plugin_error_225eb494 from 'nuxt_plugin_error_225eb494' // Source: ../plugins/error (mode: 'all')
import nuxt_plugin_redirect_297f79d0 from 'nuxt_plugin_redirect_297f79d0' // Source: ../plugins/redirect (mode: 'all')
import nuxt_plugin_featureDetection_7a5eb223 from 'nuxt_plugin_featureDetection_7a5eb223' // Source: ../plugins/featureDetection (mode: 'all')
import nuxt_plugin_cacheControl_7e5d9f6f from 'nuxt_plugin_cacheControl_7e5d9f6f' // Source: ../plugins/cacheControl (mode: 'all')
import nuxt_plugin_oio_caea793e from 'nuxt_plugin_oio_caea793e' // Source: ../plugins/oio (mode: 'client')
import nuxt_plugin_oet_caea7a2c from 'nuxt_plugin_oet_caea7a2c' // Source: ../plugins/oet (mode: 'client')
import nuxt_plugin_socket_412a8e67 from 'nuxt_plugin_socket_412a8e67' // Source: ../plugins/socket (mode: 'client')
import nuxt_plugin_tracking_e65013f4 from 'nuxt_plugin_tracking_e65013f4' // Source: ../modules/tracking/plugins/tracking.js (mode: 'all')
import nuxt_plugin_firebasefcm_5cb80304 from 'nuxt_plugin_firebasefcm_5cb80304' // Source: ../plugins/firebase-fcm (mode: 'client')
import nuxt_plugin_meta_b5aab5ac from 'nuxt_plugin_meta_b5aab5ac' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"tr"},"title":"Onedio - Sosyal İçerik Platformu","meta":[{"hid":"charset","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":"En İyi, En Güncel, En Çok Konuşulan İçerikler Onedio'da. Reklamlara boğulmadan, farklı kaynaklardan tamamen tarafsız içerikleri okuyun. Onedio, Türkiye'nin en yeni ve en hızlı büyüyen içerik sitesi."},{"name":"referrer","content":"strict-origin-when-cross-origin"},{"hid":"application-name","name":"application-name","content":"Onedio"},{"hid":"apple-itunes-app","name":"apple-itunes-app","content":"app-id=550012880"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Onedio"},{"hid":"fb:app_id","name":"fb:app_id","content":"182553655160563"},{"hid":"fb:pages","name":"fb:pages","content":"171393949589921"},{"hid":"fb:pages","name":"fb:pages","content":"221099748079276"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fonedio.com"},{"hid":"og:title","property":"og:title","content":"Onedio - Sosyal İçerik Platformu"},{"hid":"og:description","property":"og:description","content":"En İyi, En Güncel, En Çok Konuşulan İçerikler Onedio'da. Reklamlara boğulmadan, farklı kaynaklardan tamamen tarafsız içerikleri okuyun. Onedio, Türkiye'nin en yeni ve en hızlı büyüyen içerik sitesi."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fproj-assets.onedio.com\u002Fonediologo.jpg"},{"hid":"og:image:secure_url","property":"og:image:secure_url","content":"https:\u002F\u002Fproj-assets.onedio.com\u002Fonediologo.jpg"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fonedio.com"},{"hid":"twitter:domain","name":"twitter:domain","content":"onedio.com"},{"hid":"twitter:title","name":"twitter:title","content":"Onedio - Sosyal İçerik Platformu"},{"hid":"twitter:description","name":"twitter:description","content":"En İyi, En Güncel, En Çok Konuşulan İçerikler Onedio'da. Reklamlara boğulmadan, farklı kaynaklardan tamamen tarafsız içerikleri okuyun. Onedio, Türkiye'nin en yeni ve en hızlı büyüyen içerik sitesi."},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fproj-assets.onedio.com\u002Fonediologo.jpg"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:creator","name":"twitter:creator","content":"onediocom"},{"hid":"twitter:site","name":"twitter:site","content":"onediocom"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"search","type":"application\u002Fopensearchdescription+xml","href":"\u002Fopensearch.xml","title":"Onedio"},{"rel":"alternate","type":"application\u002Frss+xml","title":"Rss","href":"\u002FPublisher\u002Fpublisher-daily.rss"},{"rel":"dns-prefetch","href":"\u002F\u002Fimg-s1.onedio.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fimg-s2.onedio.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fimg.onedio.com"},{"rel":"dns-prefetch","href":"\u002F\u002Ft.onedio.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fsrv-cdn.onedio.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fstatic.onedio.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fwww.googletagmanager.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fconnect.facebook.net"},{"rel":"dns-prefetch","href":"\u002F\u002Fmc.yandex.ru"},{"rel":"dns-prefetch","href":"\u002F\u002Fwww.google-analytics.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fcdn.taboola.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fsecurepubads.g.doubleclick.net"},{"rel":"dns-prefetch","href":"\u002F\u002Fstatic.criteo.net"},{"rel":"dns-prefetch","href":"\u002F\u002Fa.teads.tv"},{"rel":"dns-prefetch","href":"\u002F\u002Fs8t.teads.tv"},{"rel":"dns-prefetch","href":"\u002F\u002Fwidget.perfectmarket.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fs1.adform.net"},{"rel":"dns-prefetch","href":"\u002F\u002Fadform.net"},{"rel":"dns-prefetch","href":"\u002F\u002Fvidstat.taboola.com"},{"rel":"preconnect","href":"\u002F\u002Fstatic.onedio.com","crossorigin":true},{"rel":"preconnect","href":"\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"preconnect","href":"\u002F\u002Fimasdk.googleapis.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Inter:wght@300;400;500;600;700&display=optional"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fapple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002Fapple-touch-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fapple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fapple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Fapple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fapple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fapple-touch-icon-120x120-precomposed.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fapple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fapple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fapple-touch-icon-152x152-precomposed.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon-180x180.png"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon-precomposed.png"}],"script":[{"innerHTML":"\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){window.dataLayer.push(arguments);}\n          window.oio = window.oio || {};\n          window.oio.init = function(...args){this.initializers = this.initializers || []; this.initializers.push(args)};\n        ","type":"text\u002Fjavascript"},{"hid":"gpt","src":"https:\u002F\u002Fsecurepubads.g.doubleclick.net\u002Ftag\u002Fjs\u002Fgpt.js","async":true},{"hid":"gptInit","innerHTML":"\n          window.PREBID_TIMEOUT = 1000;\n          window.pbjs = window.pbjs || {};\n          window.pbjs.que = window.pbjs.que || [];\n          window.googletag = window.googletag || {cmd: []};\n          googletag.cmd.push(function() {\n            googletag.pubads().enableSingleRequest();\n            googletag.pubads().collapseEmptyDivs();\n            googletag.pubads().disableInitialLoad();\n          })\n        "}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0c8eb7d0 === 'function') {
    await nuxt_plugin_plugin_0c8eb7d0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
    await nuxt_plugin_pluginutils_ea6a7e96(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_5167c258 === 'function') {
    await nuxt_plugin_intersectionobserver_5167c258(app.context, inject)
  }

  if (typeof nuxt_plugin_image_aaba817e === 'function') {
    await nuxt_plugin_image_aaba817e(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_7007b3d1 === 'function') {
    await nuxt_plugin_deviceplugin_7007b3d1(app.context, inject)
  }

  if (typeof nuxt_plugin_device_270d8d4a === 'function') {
    await nuxt_plugin_device_270d8d4a(app.context, inject)
  }

  if (typeof nuxt_plugin_services_ac10db5c === 'function') {
    await nuxt_plugin_services_ac10db5c(app.context, inject)
  }

  if (typeof nuxt_plugin_error_225eb494 === 'function') {
    await nuxt_plugin_error_225eb494(app.context, inject)
  }

  if (typeof nuxt_plugin_redirect_297f79d0 === 'function') {
    await nuxt_plugin_redirect_297f79d0(app.context, inject)
  }

  if (typeof nuxt_plugin_featureDetection_7a5eb223 === 'function') {
    await nuxt_plugin_featureDetection_7a5eb223(app.context, inject)
  }

  if (typeof nuxt_plugin_cacheControl_7e5d9f6f === 'function') {
    await nuxt_plugin_cacheControl_7e5d9f6f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_oio_caea793e === 'function') {
    await nuxt_plugin_oio_caea793e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_oet_caea7a2c === 'function') {
    await nuxt_plugin_oet_caea7a2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socket_412a8e67 === 'function') {
    await nuxt_plugin_socket_412a8e67(app.context, inject)
  }

  if (typeof nuxt_plugin_tracking_e65013f4 === 'function') {
    await nuxt_plugin_tracking_e65013f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firebasefcm_5cb80304 === 'function') {
    await nuxt_plugin_firebasefcm_5cb80304(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_b5aab5ac === 'function') {
    await nuxt_plugin_meta_b5aab5ac(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
